import Admin from "@system/config/admin";
import Api from "../APIHandler";

const API = new Api({});

class AdminCommonAPICall {

    getRoleList = async (params = {}) => {
        let res = [];
        let param = {};
        param.params = params
        await API.get(Admin.GET_ROLE_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
        return res;
    };

    getOrgList = async (params = {}) => {
        let res = {};
        let param = {};
        param.data = { ...params }
        await API.get(Admin.GET_ORG_LIST, params).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
        return res;
    };

    fetchBomManagementList = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Admin.GET_BOM_VIEWER, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).catch((e) => {
            res = e?.response?.status
        });

        return res;
    };

    fetchBomDetailsManagementList = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Admin.GET_BOM_VIEWER_DETAILS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer?.data?.data
            }
        });
        return res;
    };

    fetchComplianceManagementList = async (params) => {
        let res = {};
        const param = {}
        param.data = params
        let url = Admin.GET_COMPLIANCE_LIST;
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data?.data?.eccnData
            }
        }).catch(err => {
            res = []
        });
        return res;
    }

}

export default AdminCommonAPICall;